'use client';

import { useEffect } from 'react';
import { Button, Signage } from '@kcd/design-system';

import { TrackPage } from '~/app/common/components';
import { useGoHome } from '~/app/hooks';
import { logError } from '~/utils/datadog';

import { DataErrorImg } from '~/assets/img/common';

export default function NotFoundPage() {
  const goHome = useGoHome('replace');

  useEffect(() => {
    logError(new Error(`Page Not Found :: ${window.location.href}`));
  }, []);

  return (
    <>
      <TrackPage page="캐시노트마켓/404" />
      <Signage
        verticalCenter
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        marginTop={0 as any}
        image={() => (
          <img src={DataErrorImg.src} className="size-64" alt="error guide" />
        )}
        className="!h-screen"
        title="페이지를 찾을 수 없습니다"
        description={
          <p className="text-hint typo-caption100-regular">
            서비스 이용에 불편을 드려 죄송합니다. <br /> 일시적인 장애이거나
            네트워크 문제일 수 있습니다.
            <br /> 잠시 후 다시 시도해주세요.
          </p>
        }
        action={
          <Button
            size="sm"
            className="-mt-16"
            variant="outline"
            onClick={goHome}
          >
            캐시노트마켓 홈으로 이동
          </Button>
        }
      />
    </>
  );
}
